export const createLocalLink = url => {
  if (`#` === url) {
    return null
  }
  return url.includes(process.env.WORDPRESS)
    ? url.replace(process.env.WORDPRESS, ``)
    : url.replace(process.env.SITE, '')
}
